import { render, staticRenderFns } from "./SetGoalConfig.vue?vue&type=template&id=6a310c47&scoped=true"
import script from "./SetGoalConfig.vue?vue&type=script&lang=js"
export * from "./SetGoalConfig.vue?vue&type=script&lang=js"
import style0 from "./SetGoalConfig.vue?vue&type=style&index=0&id=6a310c47&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a310c47",
  null
  
)

export default component.exports